import { badgeStylesParams } from '@settings/Tabs/Design/Badge/stylesParams';
import { bgBordersStylesParams } from '@settings/Tabs/Design/BGBorders/stylesParams';
import { buttonStylesParams } from '@settings/Tabs/Design/Button/stylesParams';
import { dividerStylesParams } from '@settings/Tabs/Design/Divider/stylesParams';
import { textStylesParams } from '@settings/Tabs/Design/Text/stylesParams';

export default {
  ...badgeStylesParams,
  ...bgBordersStylesParams,
  ...buttonStylesParams,
  ...dividerStylesParams,
  ...textStylesParams,
};
